import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./SMSPlatform.css";

const SMSPlatform = () => {
  const navigate = useNavigate();

  const onLogo1ContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onHomeContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onAboutContainerClick = useCallback(() => {
    navigate("/aboutus");
  }, [navigate]);

  const onOurProductsTextClick = useCallback(() => {
    navigate("/our-products");
  }, [navigate]);

  const onButtonDesktopSecondaryContainerClick = useCallback(() => {
    navigate("/login");
  }, [navigate]);

  const onButtonDesktopPrimaryContainerClick = useCallback(() => {
    navigate("/step1");
  }, [navigate]);

  return (
    <div className="sms-platform-div1">
      <div className="nav-div5">
        <div className="logo1-div13" onClick={onLogo1ContainerClick}>
          <img className="vector-icon340" alt="" src="../vector340.svg" />
          <img className="vector-icon341" alt="" src="../vector341.svg" />
          <img className="vector-icon342" alt="" src="../vector342.svg" />
          <img className="vector-icon343" alt="" src="../vector343.svg" />
          <img className="vector-icon344" alt="" src="../vector344.svg" />
          <img className="vector-icon345" alt="" src="../vector345.svg" />
          <img className="vector-icon346" alt="" src="../vector346.svg" />
          <img className="vector-icon347" alt="" src="../vector347.svg" />
          <img className="vector-icon348" alt="" src="../vector348.svg" />
          <img className="vector-icon349" alt="" src="../vector349.svg" />
          <img className="vector-icon350" alt="" src="../vector350.svg" />
          <img className="vector-icon351" alt="" src="../vector351.svg" />
          <img className="vector-icon352" alt="" src="../vector352.svg" />
          <img className="vector-icon353" alt="" src="../vector353.svg" />
          <img className="vector-icon354" alt="" src="../vector354.svg" />
          <img className="vector-icon355" alt="" src="../vector355.svg" />
          <img className="vector-icon356" alt="" src="../vector356.svg" />
          <img className="vector-icon357" alt="" src="../vector357.svg" />
          <img className="vector-icon358" alt="" src="../vector358.svg" />
          <img className="vector-icon359" alt="" src="../vector359.svg" />
          <img className="vector-icon360" alt="" src="../vector360.svg" />
          <img className="vector-icon361" alt="" src="../vector361.svg" />
          <img className="vector-icon362" alt="" src="../vector362.svg" />
          <img className="vector-icon363" alt="" src="../vector363.svg" />
          <img className="vector-icon364" alt="" src="../vector364.svg" />
          <b className="shuleeazy-b15">ShuleEazy</b>
        </div>
        <div className="frame-div228">
          <div className="frame-div229">
            <div className="home-div4" onClick={onHomeContainerClick}>
              <b className="home-b5">Home</b>
            </div>
            <div className="home-div4" onClick={onAboutContainerClick}>
              <b className="home-b5">About Us</b>
            </div>
            <div className="products-div6">
              <div className="frame-div230">
                <b className="our-products-b5" onClick={onOurProductsTextClick}>
                  Our Products
                </b>
                <img
                  className="outline-24px-chevron-down5"
                  alt=""
                  src="../outline-24px--chevrondown5.svg"
                />
              </div>
            </div>
            <div className="contact-div5">
              <b className="home-b5">Contact Us</b>
            </div>
          </div>
          <div className="frame-div231">
            <div
              className="buttondesktopsecondary-div8"
              onClick={onButtonDesktopSecondaryContainerClick}
            >
              <b className="save-and-next41">log in</b>
            </div>
            <div
              className="buttondesktopprimary-div"
              onClick={onButtonDesktopPrimaryContainerClick}
            >
              <b className="save-and-next41">sign up</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SMSPlatform;
